import React, { useState } from "react";
import "./Image.styles.css";
export default function ImageSection({
  selected_pattern,
  background_color,
  initial_pattern,
  linkURL,
}) {
  let initial_color = "#1e1f26";
  let selected_pattern_state = true;
  if (selected_pattern === undefined) {
    selected_pattern_state = false;
  }
  let selected_color_state = true;
  if (background_color === undefined) {
    selected_color_state = false;
  }
  let linkURL_state = true;
  if (linkURL === undefined) {
    linkURL_state = false;
  }
  let inital_img = "";

  const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return false; // MOBILE
    } else {
      return true; // DESKTOP
    }
  };

  const [bg_w, set_bg_w] = useState(() => {
    if (getDeviceType() === false) {
      return 200;
    } else {
      return 400;
    }
  });
  const [bg_h, set_bg_h] = useState(() => {
    if (getDeviceType() === false) {
      return 300;
    } else {
      return 200;
    }
  });

  function change_bg() {
    if (linkURL_state === true) {
      setTimeout(function () {
        set_bg_w(document.querySelector(".image").width);
        set_bg_h(document.querySelector(".image").height);
      }, 100);
    }
  }
  return (
    <div>
      <section id="img-section">
        <div
          className="bg"
          style={{
            backgroundColor: selected_color_state
              ? background_color
              : initial_color,
            width: bg_w + 100,
            height: bg_h + 100,
          }}
        >
          <svg id="SVG" style={{ width: "100%", height: "100%" }}>
            <defs>
              <pattern
                id="puzzle"
                x="0"
                y="0"
                width={
                  selected_pattern_state
                    ? selected_pattern.svg_w
                    : initial_pattern.svg_w
                }
                height={
                  selected_pattern_state
                    ? selected_pattern.svg_h
                    : initial_pattern.svg_h
                }
                patternUnits="userSpaceOnUse"
              >
                <path
                  fill={`#${initial_pattern.bg_color}`}
                  d={
                    selected_pattern_state
                      ? selected_pattern.svg
                      : initial_pattern.svg
                  }
                ></path>
              </pattern>
            </defs>

            <rect x="0" y="0" width="100%" height="100%" fill="url(#puzzle)" />
          </svg>
          {linkURL_state ? (
            <img
              onLoad={() => change_bg()}
              onClick={() => {
                document.querySelector("#myfile").click();
              }}
              className="image"
              style={{ display: linkURL_state ? "block" : "none" }}
              src={linkURL_state ? linkURL : inital_img}
              alt="Screenshot"
            />
          ) : (
            <div
              className="start-msg"
              onClick={() => {
                document.querySelector("#myfile").click();
              }}
            >
              <div className="start-about">
                <p>Make your photos cool with GroovyBackground</p>
              </div>
              <div className="get-started">
                <h3>Click here to upload image</h3>
              </div>
            </div>
          )}
          {}
        </div>
      </section>
    </div>
  );
}
